import React from 'react';
import { Link } from 'react-router-dom';
import FileBase64 from 'react-file-base64';
import moment from 'moment';
import 'whatwg-fetch';
import file_upload_rules from '../../../data/file-upload-rules';
import InputUpdate from '../input/inputUpdate';
import TextAreaUpdate from '../input/textareaUpdate';
import ModalConfirm from '../modal/modalConfirm';
import SubNavBar from '../SubNavBar';
import withAuth from 'src/hoc/withAuth';

const apiPostShow = '/api/activityWall/showPost/';
const apiPostDelete = '/api/activityWall/deletePost/';
const apiPostAddAttachment = '/api/activityWall/addPostAttachment';
const apiDeleteAttachment = '/api/activityWall/removePostAttachment/';
const linkToUser = '/dashboard/user/';
const linkToWall = '/dashboard/wall/';

class DisplayPost extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      appViewNavExtended: false, // Extend the menu behind the appViewNav
      notFound: false,
      isModalDeleteAttachmentOpen: false,
      isModalDeleteOpen: false,
      textModal: {
        title: undefined,
        message: undefined,
      },
      entity: undefined,
      WallId: undefined,
      title: '____',
      text: '____',
      dateCreate: undefined,
      creator: undefined,
      attachments: undefined,
      attachmentListExtended: false,
      fileInputsAttachments: [],
      fileAttachments: {},
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.toggleAppViewNavExtended = this.toggleAppViewNavExtended.bind(this);
    this.toggleAttachmentList = this.toggleAttachmentList.bind(this);
    this.updateField = this.updateField.bind(this);
    this.delete = this.delete.bind(this);
    this.postAttachment = this.postAttachment.bind(this);
    this.deleteAttachment = this.deleteAttachment.bind(this);
    this.openModalDelete = this.openModalDelete.bind(this);
    this.openModalDeleteAttachment = this.openModalDeleteAttachment.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.addRowAttachment = this.addRowAttachment.bind(this);
    this.removeRowAttachment = this.removeRowAttachment.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  componentDidMount() {
    if (this.props.match.params.id) {
      // check if id supplied in the route
      const paramsID = this.props.match.params.id;

      let queryURL = apiPostShow;
      let graphQL =
        '{ post(id:' +
        paramsID +
        '){ id, activityWall{ id }, title, text, dateCreate, attachments{ id, name }, creator{ id, user{ id, username} } } }';

      queryURL += graphQL;
      this.props
        .authFetch(queryURL, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'GET',
        })
        .then((resp) => resp.json())
        .then(
          function (data) {
            if (data['data']['post']) {
              this.setState({
                entity: data['data']['post'],
                wallId: data['data']['post']['activityWall']['id'],
                title: data['data']['post']['title'],
                text: data['data']['post']['text'],
                dateCreate: data['data']['post']['dateCreate'],
                creator: data['data']['post']['creator'],
                attachments: data['data']['post']['attachments'],
              });
            } else {
              this.setState({ notFound: true });
            }
            //console.log(data);
          }.bind(this)
        )
        .catch(
          function (error) {
            console.log('erreur fetch post entity: \n' + error);
          }.bind(this)
        );
    }
    ///////////////////////////////////////
  }

  // Callback~
  getFiles(key, files) {
    let fileValid = true;
    console.log(files);
    if (files.file.size > file_upload_rules.sizeLimit) {
      // file too big
      this.props.openToast(false, 'La taille maximale autorisée est de 25Mo');
      fileValid = false;
    } else if (file_upload_rules.acceptedTypes.indexOf(files.file.type) === -1) {
      // file type not accepted
      this.props.openToast(false, "Le format du fichier n'est pas autorisé");
      fileValid = false;
    }

    if (fileValid) {
      let stateIndex = 'fileAttachments';

      let newFiles = this.state[stateIndex];
      newFiles[key] = files; // we need an int as the key
      this.setState({ [stateIndex]: newFiles });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.id != this.props.match.params.id) {
      // Route reloaded
      this.componentDidMount();
    }
  }

  toggleAppViewNavExtended() {
    this.setState({
      appViewNavExtended: !this.state.appViewNavExtended,
    });
  }

  toggleAttachmentList() {
    this.setState({
      attachmentListExtended: !this.state.attachmentListExtended,
    });
  }

  addRowAttachment() {
    let newInput = `input-${this.state.fileInputsAttachments.length}`;
    this.setState({
      attachmentListExtended: true,
      fileInputsAttachments: this.state.fileInputsAttachments.concat([newInput]),
    });
  }
  removeRowAttachment(key) {
    let new_fileInputs = this.state.fileInputsAttachments;
    let new_file = this.state.fileAttachments;
    new_fileInputs.splice(this.state.fileInputsAttachments.indexOf(key), 1);
    delete new_file[key];
    this.setState({
      fileInputsAttachments: new_fileInputs,
      fileAttachments: new_file,
    });
  }

  printPin(title) {
    let res = this.isPinned(title) ? title.slice(10) : title;
    return res;
  }

  isPinned(title) {
    return title && title.startsWith('/*PINNED*/');
  }

  render() {
    if (this.state.notFound === true || !this.props.match.params.id) return null;

    const { attachments } = this.state;

    let noAttachments =
      this.state.attachments != undefined && this.state.attachments.length === 0 ? (
        <span>Aucune pièce jointe</span>
      ) : (
        ''
      );

    return (
      <div id='appView' className='div-entity'>
        <SubNavBar
          toggleAppViewNavExtended={this.toggleAppViewNavExtended}
          goBack={this.props.history.goBack}
          appViewNavExtended={this.state.appViewNavExtended}
          title='Fiche Commentaire'
        >
          <div className={'appViewNavMenu-alignRight'}>
            <button onClick={this.openModalDelete} type='button' className='btn btn-sm btn-outline-success'>
              <span className='icon icon-cross'>Supprimer</span>
            </button>
          </div>
        </SubNavBar>

        <div id='appViewContent'>
          <div className='entity-display'>
            <form>
              {this.state.wallId && (
                <Link to={linkToWall + this.state.wallId}>
                  <span className='icon icon-arrow-bold-right text-clickable'>Voir mur</span>
                </Link>
              )}
              <InputUpdate
                inputType={'text'}
                inputLabel={'Titre'}
                inputValue={this.state.title}
                submitUpdate={(inputValue) => this.updateField(inputValue, 'text', 'title')}
                toggleBlackOut={() => this.props.toggleBlackOut()}
              />
              <div className='form-group'>
                <label>Créé le</label>
                <input
                  name='dateCreate'
                  value={moment(this.state.dateCreate).format('DD-MM-YY à HH:mm')}
                  onChange={this.handleInputChange}
                  type='text'
                  className='form-control'
                  readOnly
                />
              </div>
              {this.state.creator && (
                <div className='form-group'>
                  <label>Créateur</label>
                  <Link to={linkToUser + this.state.creator.user.id}>
                    <input
                      name='creator'
                      value={this.state.creator.user.username}
                      onChange={this.handleInputChange}
                      type='text'
                      className='form-control'
                      readOnly
                    />
                  </Link>
                </div>
              )}
              <div className='form-group'>
                <div className='alignHorizontal'>
                  <label className='cursor bold' onClick={this.toggleAttachmentList}>
                    Pièces jointes ({attachments ? attachments.length : '_'})
                    <span
                      className={
                        'icon ' +
                        (this.state.attachmentListExtended ? 'icon-chevron-thin-up ' : 'icon-chevron-thin-down ')
                      }
                    ></span>
                  </label>
                  <button onClick={this.addRowAttachment} type='button' className='btn btn-sm btn-outline-success'>
                    <span className='icon icon-plus'></span>
                  </button>
                </div>
                {this.state.attachmentListExtended && (
                  <div>
                    {this.state.fileInputsAttachments.map((fileInput) => (
                      <div className='alignHorizontal'>
                        <FileBase64
                          key={fileInput}
                          className='btn btn-sm btn-outline-success'
                          multiple={false}
                          onDone={this.getFiles.bind(this, fileInput)}
                        />
                        <button
                          onClick={() => this.removeRowAttachment(fileInput)}
                          type='button'
                          className='btn btn-sm btn-outline-success'
                        >
                          <span className='icon icon-cross'></span>
                        </button>
                        {this.state.fileAttachments[fileInput] && this.state.fileAttachments[fileInput].base64 && (
                          <button
                            onClick={() => this.postAttachment(fileInput)}
                            type='button'
                            className='btn btn-sm btn-outline-success'
                          >
                            <span className='icon icon-check'>Sauvegarder</span>
                          </button>
                        )}
                      </div>
                    ))}
                    {attachments ? (
                      <div>
                        {attachments.map((file) => (
                          <li className='list-group-item entity-row' key={file.id}>
                            <a target='_blank' href={'/' + file.name}>
                              <span className='icon icon-attachment'>
                                {file.name.split('/')[file.name.split('/').length - 1]}
                              </span>
                            </a>
                            <button
                              onClick={() => this.openModalDeleteAttachment(file.id)}
                              type='button'
                              className='btn btn-sm btn-outline-success'
                            >
                              <span className='icon icon-cross'></span>
                            </button>
                          </li>
                        ))}
                        {noAttachments}
                      </div>
                    ) : (
                      <span>Chargement...</span>
                    )}
                  </div>
                )}
              </div>
              <TextAreaUpdate
                inputType={'text'}
                inputLabel={'Commentaire'}
                inputValue={this.state.text}
                submitUpdate={(inputValue) => this.updateField(inputValue, 'text', 'text')}
                toggleBlackOut={() => this.props.toggleBlackOut()}
              />
            </form>
          </div>
        </div>

        <ModalConfirm
          className='myModal'
          modalText={this.state.textModal}
          isOpen={this.state.isModalDeleteAttachmentOpen}
          onSubmit={this.deleteAttachment}
          onClose={this.closeModal}
          onCancel={this.closeModal}
        ></ModalConfirm>

        <ModalConfirm
          className='myModal'
          modalText={this.state.textModal}
          isOpen={this.state.isModalDeleteOpen}
          onSubmit={this.delete}
          onClose={this.closeModal}
          onCancel={this.closeModal}
        ></ModalConfirm>
      </div>
    );
  }

  openModalDelete() {
    let modal = {
      title: 'Suppression',
      message: 'Vous allez supprimer ce commentaire',
    };
    this.props.toggleBlackOut();
    this.setState({
      textModal: modal,
      isModalDeleteOpen: true,
      appViewNavExtended: false,
    });
  }

  openModalDeleteAttachment(attachmentId) {
    let modal = {
      title: 'Suppression',
      message: 'Vous allez supprimer cette pièce-jointe',
    };
    this.props.toggleBlackOut();
    this.setState({
      textModal: modal,
      isModalDeleteAttachmentOpen: true,
      attachmentToDeleteId: attachmentId,
    });
  }

  closeModal() {
    this.props.toggleBlackOut();
    this.setState({
      isModalDeleteAttachmentOpen: false,
      isModalDeleteOpen: false,
    });
  }

  updateField(newValue, inputType, fieldName) {
    // !! Important-> the given "fieldName" attribute must be the name of the ORM attribute !!
    let newValueSent;
    if (inputType == 'text') {
      newValueSent = '"' + newValue.replace(/["]/g, '\\"') + '"';
    } else {
      newValueSent = newValue;
    }
    let graphQL = 'mutation { post(id:' + this.props.match.params.id + ', ';
    graphQL += fieldName + ':' + newValueSent + ') { ' + fieldName + ' } }';

    let queryURL = apiPostShow;
    let data = 'data=' + encodeURIComponent(graphQL);
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        method: 'POST',
        body: data,
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          if (data['data']['post'][fieldName] == newValue) {
            this.props.openToast(true, 'Votre modification a bien été prise en compte.');
          } else {
            this.props.openToast(false, 'Erreur lors de la modification. Veuillez réessayer.');
          }
        }.bind(this)
      )
      .catch(
        function () {
          console.log('erreur fetch UPDATE post entity');
        }.bind(this)
      );
  }

  postAttachment(fileInput) {
    let file = this.state.fileAttachments[fileInput];

    let payload = {
      post: {
        id: this.props.match.params.id,
      },
      attachment: {
        typeOfFile: file.type.split('/')[1],
        filename: file.name.split('.')[0],
      },
    };

    let data = 'metadata=' + encodeURIComponent(JSON.stringify(payload));
    data += '&';
    data += 'base64=' + encodeURIComponent(file.base64.split('base64,')[1]);

    this.props
      .authFetch(apiPostAddAttachment, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        method: 'POST',
        body: data,
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          let isValid = data.isValid;
          if (isValid) {
            this.componentDidMount();
            this.props.openToast(true, 'Le fichier a été sauvegardé');
            this.removeRowAttachment(fileInput);
          } else {
            this.props.openToast(false, 'Erreur sauvegarde. Veuillez réessayer');
          }
        }.bind(this)
      )
      .catch(
        function (rror) {
          console.log(rror);
          this.props.openToast(false, 'Erreur sauvegarde. Veuillez réessayer');
        }.bind(this)
      );
  }

  deleteAttachment() {
    let json = {
      post: {
        id: this.props.match.params.id,
      },
      attachment: {
        id: this.state.attachmentToDeleteId,
      },
    };
    let queryURL = apiDeleteAttachment;
    queryURL += encodeURIComponent(JSON.stringify(json));
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'DELETE',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          let isValid = data.isValid;
          if (isValid) {
            this.componentDidMount();
            this.props.openToast(true, 'Vous venez de supprimer le fichier');
          } else {
            this.props.openToast(false, 'Erreur suppression fichier. Veuillez réessayer');
          }
        }.bind(this)
      )
      .catch(
        function (rror) {
          this.props.openToast(false, 'Erreur suppression fichier. Veuillez réessayer');
          console.log(rror);
        }.bind(this)
      );
  }

  delete() {
    let queryURL = apiPostDelete;
    let json = {
      post: {
        id: this.props.match.params.id,
      },
    };
    queryURL += encodeURIComponent(JSON.stringify(json));
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'DELETE',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          if (data['isValid'] == true) {
            this.props.openToast(true, 'Le commentaire a bien été supprimé');
            this.props.history.push(linkToWall + this.state.wallId);
          } else {
            this.props.openToast(false, 'Erreur suppression du commentaire');
          }
          //console.log(data);
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch delete post: \n' + error);
          this.props.openToast(false, 'Suppression impossible');
        }.bind(this)
      );
  }
}

export default withAuth(DisplayPost);
